import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { elegir } from 'elegir';
import { setPropTypes, PropTypes } from 'proper-types';
import { compose, defaultProps, setDisplayName, withProps } from 'recompose';
import { withUniqueFormIdentifier, withHoverProps, withFocusProps } from '@klarna/higher-order-components';
import format from 'date-fns/format';
import { DatePickerMain } from '@bubble-ui/molecule-date-picker';
import ActionIconClose from '@bubble-ui/icon-action-close';
import ActionIconArrowRight from '@bubble-ui/icon-action-arrow-right';
import ParagraphSecondary from '@bubble-ui/molecule-paragraph-body';
import IconCalendar from '@bubble-ui/icon-calendar';
import TouchableIcon from '@bubble-ui/molecule-touchable-icon';
import Touchable from '@bubble-ui/primitive-touchable';
import View from '@bubble-ui/primitive-view';
import LabelParticle from '@bubble-ui/atom-label';
import wrapOverridableComponent from '@bubble-ui/hoc-wrap-overridable-component';
import withOnEnterAndOnTab from '@bubble-ui/hoc-with-on-enter-and-on-tab';
import { withDesignVersion } from '@bubble-ui/provider-design-version';
import { Motion, spring } from '@bubble-ui/primitive-motion';
import * as Layers from '@bubble-ui/particle-layers';
import { ColorFunctions as Colors } from '@bubble-ui/particle-colors';
import * as FontSizes from '@bubble-ui/particle-font-sizes';
import * as FontFamilies from '@bubble-ui/particle-font-families';
import omitProps from '@hocs/omit-props';
import { platformSelect } from '@bubble-ui/util-platform';

var calculateBorderColor = function calculateBorderColor(_ref) {
  var designVersion = _ref.designVersion,
      focused = _ref.focused,
      hovered = _ref.hovered,
      isExpanded = _ref.isExpanded;
  return elegir( // hovered
  hovered, Colors.__borderNeutralHovered(designVersion), // focused
  isExpanded || focused, Colors.__borderDefault(designVersion), // default
  true, Colors.__borderNeutral(designVersion));
};

var getDefaultStyleSheet = function getDefaultStyleSheet(_ref2) {
  var designVersion = _ref2.designVersion,
      isExpanded = _ref2.isExpanded,
      focused = _ref2.focused,
      width = _ref2.width;
  return {
    rootStyle: {
      flexGrow: 1,
      flexShrink: 1
    },
    fieldStyle: _objectSpread(_objectSpread({
      alignItems: 'end',
      boxShadow: 'none',
      cursor: 'pointer',
      caretColor: Colors.__textAccent(designVersion).toString(),
      color: Colors.__textDefault(designVersion).toString()
    }, FontFamilies.KLARNA_TEXT_MEDIUM), {}, {
      fontSize: FontSizes.SIZE_DEFAULT,
      height: 60,
      lineHeight: 40,
      opacity: 1,
      overflow: 'hidden',
      paddingLeft: 0,
      paddingTop: 19,
      position: 'absolute',
      top: 0,
      textOverflow: 'ellipsis',
      display: 'flex',
      flexDirection: 'row',
      transition: 'color 0.2s ease',
      whiteSpace: 'nowrap',
      minWidth: 240,
      border: 0,
      background: 'transparent',
      outline: 'none'
    }),
    containerStyle: {
      alignItems: 'stretch',
      borderBottomWidth: isExpanded || focused ? 2 : 1,
      borderStyle: 'solid',
      boxSizing: 'border-box',
      cursor: 'pointer',
      flexDirection: 'row',
      height: 60,
      justifyContent: 'space-between',
      position: 'relative',
      width: width
    },
    labelTextStyle: function labelTextStyle(fontSize) {
      return _objectSpread(_objectSpread({
        color: Colors.__textNeutral(designVersion)
      }, FontFamilies.KLARNA_TEXT_REGULAR), {}, {
        fontSize: fontSize,
        lineHeight: 30,
        overflow: 'hidden',
        textAlign: 'left',
        textOverflow: 'ellipsis',
        transition: 'color 0.2s ease',
        whiteSpace: 'nowrap',
        width: '100%'
      });
    },
    labelViewStyle: function labelViewStyle(marginTop) {
      return {
        marginTop: marginTop,
        backgroundColor: Colors.transparent(designVersion).toString(),
        opacity: 1,
        pointerEvents: 'none',
        width: '100%'
      };
    },
    dateStyle: {},
    arrowStyle: _objectSpread(_objectSpread({}, platformSelect({
      web: {
        alignSelf: 'end'
      },
      default: {}
    })), {}, {
      height: 30,
      padding: 5,
      top: 0
    }),
    datePickerStyle: {
      position: 'absolute',
      zIndex: Layers.DIALOG,
      top: 75,
      left: 0
    },
    iconStyle: {
      alignSelf: 'center',
      height: 20,
      paddingLeft: 15,
      top: isExpanded ? 1 : 0
    },
    textWrapperStyle: {
      flexDirection: 'column',
      flexGrow: 0,
      flexShrink: 1,
      position: 'relative',
      width: '100%'
    }
  };
};

export var DateRangeField = /*#__PURE__*/function (_React$Component) {
  _inherits(DateRangeField, _React$Component);

  var _super = _createSuper(DateRangeField);

  function DateRangeField(props) {
    var _this;

    _classCallCheck(this, DateRangeField);

    _this = _super.call(this, props);
    _this.onKeyDown = _this.onKeyDown.bind(_assertThisInitialized(_this));
    _this.onClearRange = _this.onClearRange.bind(_assertThisInitialized(_this));
    _this.handleRef = _this.handleRef.bind(_assertThisInitialized(_this));
    _this.handleWindowClick = _this.handleWindowClick.bind(_assertThisInitialized(_this));
    _this.onToggle = _this.onToggle.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DateRangeField, [{
    key: "handleRef",
    value: function handleRef(domElement) {
      this.domElement = domElement;
    }
  }, {
    key: "handleWindowClick",
    value: function handleWindowClick(e) {
      if (this.domElement && !this.domElement.contains(e.target)) {
        this.props.onToggle();
      }
    }
  }, {
    key: "onClickPicker",
    value: function onClickPicker(e) {
      e.stopPropagation();
    }
  }, {
    key: "onToggle",
    value: function onToggle(e) {
      e.stopPropagation();
      e.preventDefault();
      this.props.onToggle();
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(event) {
      if (event.key === 'Escape') {
        this.props.onToggle();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isExpanded) {
        global.addEventListener('keydown', this.onKeyDown);
        global.document.addEventListener('click', this.handleWindowClick);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      global.removeEventListener('keydown', this.onKeyDown);
      global.document.removeEventListener('click', this.handleWindowClick);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.isExpanded && this.props.isExpanded) {
        global.addEventListener('keydown', this.onKeyDown);
        global.document.addEventListener('click', this.handleWindowClick);
      } else if (prevProps.isExpanded && !this.props.isExpanded) {
        global.document.removeEventListener('click', this.handleWindowClick);
        global.removeEventListener('keydown', this.onKeyDown);
      }
    }
  }, {
    key: "onClearRange",
    value: function onClearRange(e) {
      this.props.onChange([]);
      this.props.isExpanded && this.props.onToggle(); // Close if open

      e.stopPropagation();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          label = _this$props.label,
          hasLabel = _this$props.hasLabel,
          firstDayOfWeek = _this$props.firstDayOfWeek,
          startDateLabel = _this$props.startDateLabel,
          endDateLabel = _this$props.endDateLabel,
          weekDayOneLetterNames = _this$props.weekDayOneLetterNames,
          monthNames = _this$props.monthNames,
          onGoToNextMonth = _this$props.onGoToNextMonth,
          onGoToPreviousMonth = _this$props.onGoToPreviousMonth,
          currentYear = _this$props.currentYear,
          monthCurrentlyShown = _this$props.monthCurrentlyShown,
          range = _this$props.range,
          onChange = _this$props.onChange,
          onMouseOver = _this$props.onMouseOver,
          onMouseOut = _this$props.onMouseOut,
          onFocus = _this$props.onFocus,
          onBlur = _this$props.onBlur,
          isClearable = _this$props.isClearable,
          isExpanded = _this$props.isExpanded,
          formatter = _this$props.formatter,
          focused = _this$props.focused,
          hovered = _this$props.hovered,
          ids = _this$props.ids,
          name = _this$props.name,
          disableDatesHandler = _this$props.disableDatesHandler,
          presets = _this$props.presets,
          designVersion = _this$props.designVersion,
          _this$props$styleShee = _this$props.styleSheet,
          rootStyle = _this$props$styleShee.rootStyle,
          containerStyle = _this$props$styleShee.containerStyle,
          iconStyle = _this$props$styleShee.iconStyle,
          fieldStyle = _this$props$styleShee.fieldStyle,
          dateStyle = _this$props$styleShee.dateStyle,
          arrowStyle = _this$props$styleShee.arrowStyle,
          datePickerStyle = _this$props$styleShee.datePickerStyle,
          labelViewStyle = _this$props$styleShee.labelViewStyle,
          labelTextStyle = _this$props$styleShee.labelTextStyle,
          textWrapperStyle = _this$props$styleShee.textWrapperStyle;

      var _range = _slicedToArray(range, 2),
          startDate = _range[0],
          endDate = _range[1];

      var hasValue = Boolean(startDate);
      var icon = isClearable && hasValue ? /*#__PURE__*/React.createElement(TouchableIcon, {
        Icon: ActionIconClose,
        onPress: this.onClearRange
      }) : /*#__PURE__*/React.createElement(IconCalendar, null);
      var targetBorderColor = calculateBorderColor({
        designVersion: designVersion,
        focused: focused,
        hovered: hovered,
        isExpanded: isExpanded
      });
      return /*#__PURE__*/React.createElement(Motion, {
        style: {
          borderColorR: spring(targetBorderColor.red),
          borderColorG: spring(targetBorderColor.green),
          borderColorB: spring(targetBorderColor.blue),
          borderColorA: spring(targetBorderColor.alpha)
        }
      }, function (_ref3) {
        var borderColorR = _ref3.borderColorR,
            borderColorG = _ref3.borderColorG,
            borderColorB = _ref3.borderColorB,
            borderColorA = _ref3.borderColorA;
        return /*#__PURE__*/React.createElement(View, {
          id: ids.root,
          onRef: _this2.handleRef,
          style: rootStyle
        }, /*#__PURE__*/React.createElement(View, {
          id: ids.container,
          tag: "label",
          htmlFor: ids.field || name,
          onClick: _this2.onToggle,
          style: _objectSpread(_objectSpread({}, containerStyle), {}, {
            borderBottomColor: "rgba(".concat(Math.round(borderColorR), ", ").concat(Math.round(borderColorG), ", ").concat(Math.round(borderColorB), ", ").concat(borderColorA, ")")
          })
        }, /*#__PURE__*/React.createElement(View, {
          id: ids.textWrapper,
          style: textWrapperStyle
        }, hasLabel && /*#__PURE__*/React.createElement(LabelParticle, {
          hasValue: hasValue,
          focused: isExpanded,
          id: ids.label,
          viewStyle: labelViewStyle,
          textStyle: labelTextStyle
        }, label), (hasValue || isExpanded) && /*#__PURE__*/React.createElement(Touchable, {
          id: ids.field,
          style: fieldStyle,
          onFocus: onFocus,
          onBlur: onBlur,
          onMouseOut: onMouseOut,
          onMouseOver: onMouseOver,
          onPress: function onPress(e) {
            return _this2.onToggle(e);
          }
        }, /*#__PURE__*/React.createElement(View, {
          style: dateStyle
        }, /*#__PURE__*/React.createElement(ParagraphSecondary, {
          medium: true
        }, startDate ? formatter(startDate) : startDateLabel)), /*#__PURE__*/React.createElement(View, {
          style: arrowStyle
        }, /*#__PURE__*/React.createElement(ActionIconArrowRight, {
          colorToken: isExpanded && !startDate || !isExpanded && !endDate ? 'colors/text/neutral' : 'colors/text/default'
        })), /*#__PURE__*/React.createElement(View, {
          style: dateStyle
        }, /*#__PURE__*/React.createElement(ParagraphSecondary, {
          medium: true,
          light: isExpanded && !startDate || !isExpanded && !endDate
        }, endDate ? formatter(endDate) : endDateLabel)))), icon && /*#__PURE__*/React.createElement(View, {
          id: ids.icon,
          style: iconStyle
        }, icon)), isExpanded && /*#__PURE__*/React.createElement(View, {
          id: ids.picker,
          style: datePickerStyle,
          onClick: _this2.onClickPicker
        }, /*#__PURE__*/React.createElement(DatePickerMain, {
          rangeSelection: true,
          monthNames: monthNames,
          weekDayOneLetterNames: weekDayOneLetterNames,
          currentYear: currentYear,
          firstDayOfWeek: firstDayOfWeek,
          monthCurrentlyShown: monthCurrentlyShown,
          onGoToPreviousMonth: onGoToPreviousMonth,
          onGoToNextMonth: onGoToNextMonth,
          onChange: onChange,
          disableDatesHandler: disableDatesHandler,
          presets: presets,
          value: range
        })));
      });
    }
  }]);

  return DateRangeField;
}(React.Component);
export default compose(setDisplayName('DateRangeField'), setPropTypes({
  id: PropTypes.string,
  formatter: PropTypes.func.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  isClearable: PropTypes.bool,
  label: PropTypes.string.isRequired,
  monthCurrentlyShown: PropTypes.string.isRequired,
  currentYear: PropTypes.string.isRequired,
  monthNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  weekDayOneLetterNames: PropTypes.object.isRequired,
  firstDayOfWeek: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  onGoToNextMonth: PropTypes.func.isRequired,
  onGoToPreviousMonth: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired,
  range: PropTypes.arrayOf(PropTypes.string).isRequired,
  startDateLabel: PropTypes.string.isRequired,
  endDateLabel: PropTypes.string.isRequired
}), withUniqueFormIdentifier, withProps(function (_ref4) {
  var label = _ref4.label,
      range = _ref4.range;
  return {
    hasLabel: label && label.length > 0,
    hasValue: range && range.length > 0 && Boolean(range[0])
  };
}), withHoverProps({
  hovered: true
}), withFocusProps({
  focused: true
}), defaultProps({
  range: [null, null],
  isClearable: true,
  firstDayOfWeek: 1,
  monthCurrentlyShown: format(Date.now(), 'yyyy-MM'),
  currentYear: format(Date.now(), 'yyyy'),
  onKeyDown: function onKeyDown() {},
  onTab: function onTab() {},
  onEnter: function onEnter() {}
}), withOnEnterAndOnTab, withProps(function (_ref5) {
  var id = _ref5.id;
  return {
    ids: id ? {
      root: "".concat(id, "__root"),
      container: "".concat(id, "__container"),
      icon: "".concat(id, "__icon"),
      textWrapper: "".concat(id, "__text-wrapper"),
      label: "".concat(id, "__label"),
      field: id,
      picker: "".concat(id, "__picker")
    } : {}
  };
}), withDesignVersion, wrapOverridableComponent('DateRangeField', getDefaultStyleSheet), omitProps('designVersion'))(DateRangeField);
//# sourceMappingURL=index.js.map